<template>
  <div
    style="
      width: 100%;
      height: calc(100% - 50px);
      overflow-y: auto;
      padding: 0 10px;
      box-sizing: border-box;
    "
    v-loading="loading"
  >
    <el-row
      style="
        text-align: right;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: right;
      "
    >
      <div style="flex: 1; text-align: right; margin-right: 10px">
        <el-button
          @click="submitProjectData"
          type="warning"
          size="mini"
          :disabled="disabled"
          v-if="(Grade == '1' || Grade == '3') && !disabled"
          icon="el-icon-upload2"
          >提交</el-button
        >
        <el-button
          @click="submitData"
          type="primary"
          size="mini"
          :disabled="disabled"
          v-if="!disabled"
          >保存</el-button
        >
      </div>
      <div style="margin-right: 20px">
        <el-tag v-if="Status == 0" type="warning" size="medium"
          >当前状态：未提交
        </el-tag>
        <el-tag v-if="Status == 1" type="warning" size="medium"
          >当前状态：已提交
        </el-tag>
        <el-tag v-if="Status == 2 || Status == 3" type="success" size="medium"
          >当前状态：已审核
        </el-tag>
        <el-tag
          v-if="Status == 4"
          style="
            background-color: #ebb563;
            color: #ffffff;
            border-color: #ebb563;
          "
          size="medium"
          >当前状态：驳回
        </el-tag>
      </div>
    </el-row>
    <div style="display: flex; width: 100%">
      <div style="width: calc(100% - 260px); border-right: 1px solid #dcdfe6">
        <el-table
          :data="tableData"
          style="width: 100%; overflow-y: auto"
          max-height="calc(100% - 50px)"
        >
          <el-table-column
            v-for="tableItem in titleData"
            :key="tableItem.FiledKey"
            :label="tableItem.FieldName"
            :prop="tableItem.FiledKey"
          >
            <template slot-scope="scope">
              <el-input
                :disabled="disabled"
                v-model="scope.row[tableItem.FiledKey]"
                placeholder="请输入"
                style="width: 100%"
                :type="
                  tableItem.ComponentType === 'InputText' ? 'text' : 'number'
                "
                resize="none"
                size="mini"
                v-if="!scope.row.Id"
              ></el-input>
              <span v-else>{{ scope.row[tableItem.FiledKey] }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="SupplierName" label="填写人">
          </el-table-column>
          <el-table-column label="操作" width="100px" v-if="!disabled">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="color: #f56c6c"
                @click="TableDeleteRow(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div
          style="height: 50px; width: 100%; display: flex; align-items: center"
        >
          <el-button
            icon="el-icon-plus"
            circle
            style="font-size: 14px"
            type="primary"
            @click="TableAddRow"
            :disabled="disabled"
            v-if="!disabled"
          ></el-button>
        </div>
        <div
          style="
            display: flex;
            width: 100%;
            align-items: center;
            font-size: 14px;
            margin-top: 10px;
            margin-bottom: 10px;
            color: #ebb563;
          "
          v-if="approvalComments['Spares'] && RejectReason && Status == 4"
        >
          <span
            style="
              display: inline-block;
              width: 100px;

              font-weight: bold;

              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 10px;
            "
            >审核意见</span
          >
          <span style="display: inline-block; width: calc(100% - 120px)">
            {{ approvalComments['Spares'].content }}
          </span>
          <!-- <el-input
              v-model="approvalComments[eell.Type].content"
              placeholder="未输入内容"
              style="width: calc(100% - 120px)"
              type="textarea"
              :rows="2"
              disabled
              resize="none"
              size="mini"
            ></el-input> -->
        </div>
      </div>
      <div style="width: 220px; margin-left: 20px" :class="StatuClass">
        <div
          v-for="(ele, index) in TypeData"
          :key="ele.Type"
          :style="`height: calc(100% / ${TypeData.length});min-height: 150px;`"
        >
          <div style="height: 100%; display: flex">
            <div class="steps-left">
              <div
                :class="['steps', tableData?.length > 0 ? 'steps-success' : '']"
              >
                <i :class="'el-icon-check'" v-if="tableData?.length > 0"></i>
                <span v-else>{{ index + 1 }}</span>
              </div>
              <!-- <div
                :class="[
                  'steps-left-line',
                  tableData?.length > 0 ? 'steps-success-line' : '',
                ]"
                v-if="index != tableData.length - 1"
              ></div> -->
            </div>
            <div class="steps-right">
              <div class="steps-right-title">
                <span
                  :class="[tableData?.length > 0 ? 'steps-success' : '']"
                  style="cursor: pointer"
                  >{{ index + 1 }}.{{ ele.TypeName }}</span
                >
              </div>
              <!-- <div
                class="steps-right-description"
                v-if="approvalComments[ele.Type]"
              >
                <div class="approval-comment">
                  <el-tooltip effect="dark" placement="left" :open-delay="300">
                    <div slot="content" style="width: 300px">
                      {{ approvalComments[ele.Type].content }}
                    </div>
                    <div class="comment-content">
                      {{ approvalComments[ele.Type].content }}
                    </div>
                  </el-tooltip>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
import moment from 'moment'

export default {
  data() {
    return {
      Grade: null,
      TokenCache,
      tableData: [],
      titleData: [],
      disabled: false,
      base_Supplier: {},
      isUpCheckbox: false,
      loading: false,
      TypeData: [
        {
          Type: 'Spares',
          TypeName: '通用配件',
        },
      ],
      moment,
      Status: '',
      RejectReason: '',
      approvalComments: {},
    }
  },
  props: {},
  components: {},
  methods: {
    TableAddRow() {
      let obj = {}
      this.titleData.forEach((item) => {
        this.$set(obj, item.FiledKey, '')
      })
      this.$set(this.tableData, this.tableData.length, obj)
    },
    //删除数据
    async TableDeleteRow(index, row) {
      if (row.Id) {
        this.$confirm('删除后不可恢复，您确定要删除当前通用配件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$http
            .post(
              `/Device_TypeWork/Device_TypeTemplate/DeleteUniversalAccessories?Id=${row.Id}`
            )
            .then((res) => {
              if (res.Success) {
                this.$notify.success('删除成功')
                this.tableData.splice(index, 1)
              } else {
                this.$notify.error(res.Msg)
              }
            })
        })
      } else {
        this.tableData.splice(index, 1)
      }
    },
    //提交项目数据
    submitProjectData() {
      let flag = this.tableData.every((item) => {
        return item.Id
      })
      if (!flag) {
        return this.$notify.error('请填写通用配件信息后提交')
      }
      this.$confirm(
        '您确定要提交当前通用配件吗？提交后将不可更改, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loading = true
        this.$http
          .post(
            `/Device_TypeWork/Device_TypeTemplate/SubmitUniversalAccessories?ProjectId=${this.base_Supplier.ProjectId}&SupplierId=${this.base_Supplier.Id}`
          )
          .then((res) => {
            this.loading = false
            if (res.Success) {
              this.$notify.success('通用配件提交成功')
              this.disabled = true
              this.Status = 1
              this.getDataList()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    //保存数据
    async submitData() {
      if (this.tableData.length == 0) {
        return this.$notify.error('请填写通用配件信息')
      }
      let tableData = this.tableData.filter((item) => {
        return !item.Id
      })
      if (tableData.length == 0) {
        return this.$notify.error('检测到未添加通用配件，请检查')
      }
      this.$confirm('您确定要保存当前已填写通用配件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post(
            '/Device_TypeWork/Device_TypeTemplate/SaveUniversalAccessories',
            {
              ProjectId: this.base_Supplier.ProjectId,
              SupplierId: this.base_Supplier.Id,
              device_Accessories: [...tableData],
            }
          )
          .then((res) => {
            this.loading = false
            if (res.Success) {
              this.$notify.success('保存成功')
              this.getDataList()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },

    getDataList() {
      this.loading = true
      this.$http
        .post(
          `/Device_TypeWork/Device_TypeTemplate/GetUniversalAccessories?ProjectId=${this.base_Supplier.ProjectId}&SupplierId=${this.base_Supplier.Id}`
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.tableData = res.Data?.TableData || []
            if (window.sessionStorage.getItem('titleData')) {
              this.titleData = JSON.parse(
                window.sessionStorage.getItem('titleData')
              )
            } else {
              this.titleData = res.Data?.titleData || []
              window.sessionStorage.setItem(
                'titleData',
                JSON.stringify(this.titleData)
              )
            }

            this.disabled =
              res.Data.Status == 1 ||
              res.Data.Status == 2 ||
              res.Data.Status == 3
                ? true
                : false
            this.Status = res.Data.Status
            this.RejectReason = res.Data?.RejectReason
            if (
              res.Data.RejectReason &&
              JSON.parse(res.Data.RejectReason).length > 0
            ) {
              JSON.parse(res.Data.RejectReason).forEach((item) => {
                this.$set(this.approvalComments, item.stepKey, item)
              })
              console.log(this.approvalComments, 'this.approvalComments')
            }
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  mounted() {},
  created() {
    this.base_Supplier = window.localStorage.getItem('base_Supplier')
      ? JSON.parse(window.localStorage.getItem('base_Supplier'))
      : {}
    console.log(this.base_Supplier, 'this.base_Supplier')
    if (this.base_Supplier.ProjectId) {
      this.getDataList()
    }
    this.Grade = window.localStorage.getItem('Grade')
  },
  computed: {
    StatuClass() {
      return `steps-box Status${this.Status}`
    },
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-list {
  padding: 5px;
}
::v-deep .upload-demo {
  display: flex;
  align-items: center;
}
.steps-box {
  .steps-left {
    width: 25px;
    height: 100%;
    margin-right: 10px;
    .steps {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 2px solid #c0c4cc;
      color: #c0c4cc;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .steps-success {
      border: 2px solid #67c23a;
      color: #67c23a;
      font-size: 18px;
    }
    .steps-left-line {
      width: 2px;
      height: calc(100% - 25px);
      background: #c0c4cc;
      margin: 0 auto;
    }
    .steps-success-line {
      background: #67c23a;
    }
  }
  .steps-right {
    width: calc(100% - 35px);
    height: 100%;
    // overflow-y: auto;
    position: relative;
    .steps-success {
      color: #67c23a;
    }
    .steps-right-title {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // position: sticky;
      // top: 0;
      // background: #fff;
      // z-index: 1;
    }
    .steps-right-description {
      font-size: 14px;

      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 5px;
      padding-right: 5px;
      height: calc(100% - 45px);
      overflow: hidden;
      position: relative;
      .comment-content {
        line-height: 1.6;
        color: #303133;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f5f7fa;
        border-radius: 4px;
      }
    }
  }
}
// .Status1 {
//   .steps-left {
//     .steps-success {
//       border: 2px solid #e6a23c;
//       color: #e6a23c;
//       font-size: 18px;
//     }
//     .steps-success-line {
//       background: #e6a23c;
//     }
//   }
//   .steps-right {
//     .steps-success {
//       color: #e6a23c;
//     }
//   }
// }
// .Status4 {
//   .steps-left {
//     .steps-success {
//       border: 2px solid #f56c6c;
//       color: #f56c6c;
//       font-size: 18px;
//     }
//     .steps-success-line {
//       background: #f56c6c;
//     }
//   }
//   .steps-right {
//     .steps-success {
//       color: #f56c6c;
//     }
//   }
// }
</style>
